import { useState } from "react";

// import axios from 'axios'
import { useDispatch, useSelector } from "react-redux"
import marvarApi from "../../../../../api/marvarApi"
import { onLogout } from "store"

import { useHelpers } from './useHelpers';
import { useGlobalStates } from './useGlobalStates';
import { useDefaultData } from './useDefaultData';
import { useForm } from './useForm';
import * as useFetchData from './useFetchData';
import { useActions } from './useActions';

export const useFechInitVehicleCredits = ({location, paramsURL}) => {

    const dispatch = useDispatch()

    const Helpers = useHelpers()

    
    const { user } = useSelector((state) => state.auth) 

    // globalStates -------------------------------------------------------------------------------
    const globalStates = useGlobalStates()

    // defaultData --------------------------------------------------------------------------------
    const defaultData = useDefaultData({Helpers})

    // Para la modal -------------------------------------------------------
    const { defaultDataModal } = defaultData
    const [ dataModal, setDataModal ] = useState(defaultDataModal)
    const toggle = (_, title, compont, dataRequest) => {
        setDataModal({
            ...defaultDataModal,
            open: !dataModal.open,
            titleModal: title,
            componentModal: compont,
            dataRequest: dataRequest
        })
    }   

    const FormRequestGlobal = useForm(defaultData.defaultFormGlobal)
    const FormDeposit = useForm(defaultData.defaultFormDeposit)
    const FormPreInvventory = useForm(defaultData.defaultFormPreInventory)
    const FormLogBook = useForm(defaultData.defaultFormLogBook)
    const FormExpenses = useForm(defaultData.defaultFormExpense)

    const Forms = {
        FormRequestGlobal,
        FormDeposit,
        FormPreInvventory,
        FormLogBook,
        FormExpenses
    }


    const defaultFetchParams = { 
        //------------- Generales
        marvarApi, user, dispatch, onLogout, location, paramsURL,
        //------------- globalStates
        // globalStates,
        //------------- defalutData
        defaultData, 
        //------------- Helpers
        Helpers,
        //------------- Forms
        Forms 
    }

    
    const fetchAllVehicleCredits = useFetchData.useFetchAllVehicleCredits({...defaultFetchParams})
    const fetchAllVehicles = useFetchData.useFetchAllVehicles({...defaultFetchParams})
    const fetchAllCustomers = useFetchData.useFetchAllCustomers({...defaultFetchParams})
    const fetchInfoCredit = useFetchData.useFetchInfoCredit({...defaultFetchParams})
    const fetchInfoQuotes = useFetchData.useFetchInfoQuote({...defaultFetchParams})
    const fetchAllQuotes = useFetchData.useFetchAllQuotes({...defaultFetchParams})
    const fetchAllFiles = useFetchData.useFetchAllFiles({...defaultFetchParams})
    const fetchAllDeposits = useFetchData.useFetchAllDeposits({...defaultFetchParams})
    const fetchInfoDeposit = useFetchData.useFetchInfoDeposit({...defaultFetchParams})
    const fetchAllCashRegisters = useFetchData.useFetchAllCashRegisters({...defaultFetchParams})
    const fetchAllBanks = useFetchData.useFetchAllBanks({...defaultFetchParams})
    const fetchAllPreInventory = useFetchData.useFetchAllPreInventory({...defaultFetchParams})
    const fetchInfoPreInventory = useFetchData.useFetchInfoPreInventory({...defaultFetchParams})
    const fetchInfoLogBook = useFetchData.useFetchInfoLogBook({...defaultFetchParams})
    const fetchAllLegalExpenses = useFetchData.useFetchAllLegalExpenses({...defaultFetchParams})
    const fetchInfoDebtsSummary = useFetchData.useFetchDebtsSummary({...defaultFetchParams})

    const FetchData = {
        fetchAllVehicleCredits,
        fetchAllVehicles,
        fetchAllCustomers,
        fetchInfoCredit,
        fetchInfoQuotes,
        fetchAllQuotes,
        fetchAllFiles,
        fetchAllDeposits,
        fetchInfoDeposit,
        fetchAllCashRegisters,
        fetchAllBanks,
        fetchAllPreInventory,
        fetchInfoPreInventory,
        fetchInfoLogBook,
        fetchAllLegalExpenses,
        fetchInfoDebtsSummary,
    }

    const Actions = useActions({
        marvarApi, toggle, Helpers, user, setDataModal,
        FetchData,
        globalStates,
        defaultData,
        Forms,
    })

    return Object.freeze({
        //------------- Generales
        dataModal, toggle, user, Helpers,
        globalStates,
        defaultData,
        FetchData,
        Forms,
        Actions
    })

}